import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { 
  Phone, Mail, ChevronDown, ChevronUp, 
  Facebook, Instagram, Twitter, Linkedin, Youtube,
  Shield, Award, Clock, Headphones, ArrowRight,
  Thermometer, Snowflake, Refrigerator, Zap, Droplets, MapPin
} from 'lucide-react';

const Footer = () => {
  const [openSection, setOpenSection] = useState(null);
  const [email, setEmail] = useState('');

  const toggleSection = (section) => {
    setOpenSection(openSection === section ? null : section);
  };

  const services = [
    { to: '/servis-talep/kombi', label: 'Kombi Servisi', icon: Thermometer },
    { to: '/klima-servisi', label: 'Klima Servisi', icon: Snowflake },
    { to: '/beyaz-esya-servisi', label: 'Beyaz Eşya', icon: Refrigerator },
    { to: '/elektrik-servisi', label: 'Elektrik', icon: Zap },
    { to: '/servis-talep/su_tesisati', label: 'Su Tesisatı', icon: Droplets },
  ];

  const populerSehirler = [
    { name: 'Ankara', slug: 'ankara-kombi-servisi', icon: '🏛️' },
    { name: 'İstanbul', slug: 'istanbul-kombi-servisi', icon: '🌉' },
    { name: 'İzmir', slug: 'izmir-kombi-servisi', icon: '⚓' },
  ];

  const company = [
    { to: '/hakkimizda', label: 'Hakkımızda' },
    { to: '/nasil-calisir', label: 'Nasıl Çalışır' },
    { to: '/garanti', label: 'HizmetGeliyo Garantisi' },
    { to: '/sss', label: 'Sık Sorulan Sorular' },
    { to: '/blog', label: 'Blog' },
    { to: '/neden-bize-katil', label: 'Usta Ol' },
    { to: '/iletisim', label: 'İletişim' },
  ];

  const legal = [
    { to: '/gizlilik', label: 'Gizlilik Politikası' },
    { to: '/kullanim-kosullari', label: 'Kullanım Koşulları' },
    { to: '/garanti-sartlari', label: 'Garanti Şartları' },
    { to: '/bilgi-guvenligi', label: 'Bilgi Güvenliği' },
  ];

  const socials = [
    { icon: Instagram, href: 'https://www.instagram.com/hizmetgeliyo/', label: 'Instagram', color: 'hover:bg-gradient-to-br hover:from-purple-600 hover:to-pink-500' },
    { icon: Youtube, href: 'https://www.youtube.com/@hizmetgeliyo', label: 'YouTube', color: 'hover:bg-red-600' },
    { icon: Facebook, href: 'https://www.facebook.com/profile.php?id=61586891289286', label: 'Facebook', color: 'hover:bg-blue-600' },
  ];

  return (
    <footer className="bg-gradient-to-b from-gray-900 to-gray-950 text-white">
      {/* Top Banner - Mobile optimized */}
      <div className="bg-gradient-to-r from-[#006D77] to-[#0A9396]">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 md:py-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-6">
            <div className="flex items-center gap-2 md:gap-3 text-white/90">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-white/20 rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0">
                <Shield className="w-4 h-4 md:w-5 md:h-5" />
              </div>
              <div>
                <p className="font-semibold text-xs md:text-sm">30 Gün Garanti</p>
                <p className="text-white/70 text-[10px] md:text-xs hidden md:block">Tüm hizmetlerde</p>
              </div>
            </div>
            <div className="flex items-center gap-2 md:gap-3 text-white/90">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-white/20 rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0">
                <Award className="w-4 h-4 md:w-5 md:h-5" />
              </div>
              <div>
                <p className="font-semibold text-xs md:text-sm">Onaylı Ustalar</p>
                <p className="text-white/70 text-[10px] md:text-xs hidden md:block">Kimlik doğrulamalı</p>
              </div>
            </div>
            <div className="flex items-center gap-2 md:gap-3 text-white/90">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-white/20 rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0">
                <Clock className="w-4 h-4 md:w-5 md:h-5" />
              </div>
              <div>
                <p className="font-semibold text-xs md:text-sm">Hızlı Hizmet</p>
                <p className="text-white/70 text-[10px] md:text-xs hidden md:block">Aynı gün randevu</p>
              </div>
            </div>
            <div className="flex items-center gap-2 md:gap-3 text-white/90">
              <div className="w-8 h-8 md:w-10 md:h-10 bg-white/20 rounded-lg md:rounded-xl flex items-center justify-center flex-shrink-0">
                <Headphones className="w-4 h-4 md:w-5 md:h-5" />
              </div>
              <div>
                <p className="font-semibold text-xs md:text-sm">7/24 Destek</p>
                <p className="text-white/70 text-[10px] md:text-xs hidden md:block">Her zaman yanınızda</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Desktop Footer */}
      <div className="hidden md:block max-w-7xl mx-auto px-8 py-12">
        <div className="grid grid-cols-12 gap-8">
          {/* Logo ve Açıklama */}
          <div className="col-span-4">
            <Link to="/" className="inline-block mb-5">
              <img src="/logo-custom.png" alt="HizmetGeliyo" className="h-12 object-contain" width="120" height="48" loading="lazy" />
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Türkiye'nin en güvenilir ev hizmetleri platformu. Kombi, klima, beyaz eşya 
              ve daha fazlası için 500+ uzman usta ile yanınızdayız.
            </p>
            
            {/* Newsletter */}
            <div className="bg-gray-800/50 rounded-2xl p-5 border border-gray-700/50">
              <h6 className="font-semibold text-white mb-2 text-sm">Bültenimize Abone Olun</h6>
              <p className="text-gray-400 text-xs mb-3">Kampanyalar ve yeniliklerden haberdar olun</p>
              <div className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="E-posta adresiniz"
                  className="flex-1 bg-gray-700/50 border border-gray-600 rounded-lg px-3 py-2 text-sm text-white placeholder-gray-500 focus:outline-none focus:border-[#006D77]"
                />
                <button className="bg-[#006D77] hover:bg-[#005a63] text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors">
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          {/* Hizmetler */}
          <div className="col-span-2">
            <h6 className="font-semibold text-white mb-5 text-sm">Hizmetler</h6>
            <ul className="space-y-3">
              {services.map((link) => {
                const Icon = link.icon;
                return (
                  <li key={link.to}>
                    <Link to={link.to} className="flex items-center gap-2 text-gray-400 hover:text-[#E29578] transition-colors text-sm">
                      <Icon className="w-4 h-4" />
                      {link.label}
                    </Link>
                  </li>
                );
              })}
            </ul>
          </div>

          {/* Kurumsal */}
          <div className="col-span-2">
            <h6 className="font-semibold text-white mb-5 text-sm">Kurumsal</h6>
            <ul className="space-y-3">
              {company.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-gray-400 hover:text-[#E29578] transition-colors text-sm">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Popüler Şehirler */}
          <div className="col-span-2">
            <h6 className="font-semibold text-white mb-5 text-sm flex items-center gap-2">
              <MapPin className="w-4 h-4 text-[#E29578]" />
              Popüler Şehirler
            </h6>
            <ul className="space-y-3">
              {populerSehirler.map((sehir) => (
                <li key={sehir.slug}>
                  <Link to={`/${sehir.slug}`} className="flex items-center gap-2 text-gray-400 hover:text-[#E29578] transition-colors text-sm">
                    <span>{sehir.icon}</span>
                    {sehir.name} Kombi Servisi
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* İletişim */}
          <div className="col-span-2">
            <h6 className="font-semibold text-white mb-5 text-sm">İletişim</h6>
            <ul className="space-y-4">
              <li>
                <a href="tel:08502427808" className="flex items-start gap-3 text-gray-400 hover:text-white transition-colors group">
                  <div className="w-9 h-9 bg-gray-800 group-hover:bg-[#006D77] rounded-lg flex items-center justify-center transition-colors">
                    <Phone className="w-4 h-4" />
                  </div>
                  <div>
                    <p className="font-semibold text-white text-sm">0850 242 78 08</p>
                    <p className="text-xs text-gray-500">Pzt-Cmt 08:00-20:00</p>
                  </div>
                </a>
              </li>
              <li>
                <a href="mailto:destek@hizmetgeliyo.com" className="flex items-start gap-3 text-gray-400 hover:text-white transition-colors group">
                  <div className="w-9 h-9 bg-gray-800 group-hover:bg-[#006D77] rounded-lg flex items-center justify-center transition-colors">
                    <Mail className="w-4 h-4" />
                  </div>
                  <div>
                    <p className="font-semibold text-white text-sm">destek@hizmetgeliyo.com</p>
                    <p className="text-xs text-gray-500">24 saat içinde yanıt</p>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Mobile Footer - Completely Redesigned */}
      <div className="md:hidden">
        {/* Logo & Description */}
        <div className="px-5 pt-8 pb-6">
          <Link to="/" className="inline-block mb-4">
            <img src="/logo-custom.png" alt="HizmetGeliyo" className="h-10 object-contain" width="100" height="40" loading="lazy" />
          </Link>
          <p className="text-gray-400 text-sm leading-relaxed">
            Türkiye'nin en güvenilir ev hizmetleri platformu. 500+ uzman usta ile yanınızdayız.
          </p>
        </div>

        {/* Quick Contact Buttons */}
        <div className="px-5 pb-6">
          <div className="flex gap-3">
            <a 
              href="tel:08502427808" 
              className="flex-1 flex items-center justify-center gap-2 bg-[#006D77] text-white rounded-2xl py-4 text-sm font-semibold"
            >
              <Phone className="w-5 h-5" />
              <span>0850 242 78 08</span>
            </a>
            <a 
              href="mailto:destek@hizmetgeliyo.com" 
              className="flex items-center justify-center bg-gray-800 text-white rounded-2xl px-5 py-4"
            >
              <Mail className="w-5 h-5" />
            </a>
          </div>
        </div>

        {/* Services Grid */}
        <div className="px-5 pb-6">
          <h6 className="font-semibold text-white mb-4 text-sm">Popüler Hizmetler</h6>
          <div className="grid grid-cols-3 gap-2">
            {services.slice(0, 6).map((link) => {
              const Icon = link.icon;
              return (
                <Link
                  key={link.to}
                  to={link.to}
                  className="flex flex-col items-center gap-2 bg-gray-800/50 rounded-xl p-3 text-center hover:bg-gray-800 transition-colors"
                >
                  <Icon className="w-5 h-5 text-[#E29578]" />
                  <span className="text-gray-300 text-xs">{link.label.split(' ')[0]}</span>
                </Link>
              );
            })}
          </div>
        </div>

        {/* Accordion Sections */}
        <div className="border-t border-gray-800">
          {[
            { id: 'kurumsal', title: 'Kurumsal', links: company },
          ].map((section) => (
            <div key={section.id} className="border-b border-gray-800">
              <button
                onClick={() => toggleSection(section.id)}
                className="w-full flex items-center justify-between px-5 py-4 text-left"
              >
                <span className="font-semibold text-sm text-white">{section.title}</span>
                {openSection === section.id ? (
                  <ChevronUp className="w-5 h-5 text-gray-400" />
                ) : (
                  <ChevronDown className="w-5 h-5 text-gray-400" />
                )}
              </button>
              {openSection === section.id && (
                <div className="px-5 pb-4 space-y-3">
                  {section.links.map((link) => (
                    <Link
                      key={link.to}
                      to={link.to}
                      className="block text-gray-400 text-sm py-1 hover:text-[#E29578] transition-colors"
                    >
                      {link.label}
                    </Link>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* Bizi Takip Edin - Social Media */}
      <div className="border-t border-gray-800 bg-gray-900/50">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-6 md:py-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4">
            <div className="text-center md:text-left">
              <h6 className="font-semibold text-white text-sm md:text-base mb-1">Bizi Takip Edin</h6>
              <p className="text-gray-400 text-xs md:text-sm">Güncel kampanya ve duyurular için sosyal medyada bizi takip edin</p>
            </div>
            <div className="flex items-center gap-3">
              {socials.map((social) => {
                const Icon = social.icon;
                return (
                  <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    className={`w-11 h-11 md:w-12 md:h-12 bg-gray-800 ${social.color} rounded-xl flex items-center justify-center transition-all duration-300 hover:scale-110`}
                  >
                    <Icon className="w-5 h-5 md:w-6 md:h-6 text-white" />
                  </a>
                );
              })}
            </div>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-gray-800 bg-gray-950">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-4">
          <p className="text-gray-500 text-xs md:text-sm text-center">
            © 2026 HizmetGeliyo. Tüm hakları saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
